// Shared between EditPaymentModal and AddUnitPicker. Kept in its own
// dependency-free module (not exported from EditPaymentModal itself)
// because those two files import each other — EditPaymentModal renders
// AddUnitPicker, and AddUnitPicker needs this palette for its own
// module-scope style objects. Having either file import from the other
// created a circular import where AddUnitPicker's top-level `inputStyle`
// tried to read `palette` before EditPaymentModal's own `const palette`
// had finished initializing ("Cannot access 'palette' before
// initialization").
export const palette = {
  primary: '#002045',
  primaryContainer: '#1a365d',
  onPrimary: '#ffffff',
  primaryFixed: '#d6e3ff',
  primaryFixedDim: '#adc7f7',
  onPrimaryFixedVariant: '#2d476f',
  surface: '#f7f9fb',
  surfaceContainerLowest: '#ffffff',
  surfaceContainer: '#eceef0',
  surfaceContainerHighest: '#e0e3e5',
  surfaceDim: '#d8dadc',
  onSurface: '#191c1e',
  onSurfaceVariant: '#43474e',
  outlineVariant: '#c4c6cf',
  tertiaryFixed: '#ffddba',
  onTertiaryFixedVariant: '#633f0f',
};

export const unitLabel = (unit) =>
  [unit.type, unit.nr && `#${unit.nr}`, unit.block].filter(Boolean).join(' ');

export const unitIcon = (unit) => (unit.type === 'APT' ? 'ri-building-2-line' : 'ri-car-line');
